import { useContext } from "react";
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AppConfigContext from "../context/AppConfigContext";

const CharacterCounter = ({ currentValue = '', maxLength = 250 }) => {
    const { config } = useContext(AppConfigContext);
    const { t, i18n } = useTranslation(config.theme, { keyPrefix: "footer" });

    const currentLength = currentValue?.length ?? 0;
    const remaining = Math.max(maxLength - currentLength, 0);

    
    const keyWithPrefix = `footer.characterText`;
    const characterText = i18n.exists(keyWithPrefix, { ns: config.theme }) ? t('characterText') : 'characters';
    return (
        <Form.Text className={`d-block w-100 text-muted`}>
            {remaining === 0
                ? `0 ${characterText} remaining`
                : `${remaining}/${maxLength} ${characterText}`}
        </Form.Text>
    );
};

export default CharacterCounter;
